export default __webpack_public_path__ + "static/media/bg.36b62619.png";